import { createReducer } from './util';
import * as actionTypes from '../typedefs/actionTypes';
import {
    LocationSettingsFetchedAction,
    RealConvoStartedAction,
    ConvoDetailsFetchedAction,
} from '../typedefs/actions';
import { Status, TeamsState } from '../typedefs/store';
import { LocationSettingsTeam } from '../typedefs/api';

const initialState: TeamsState = {};

const handlers = {
    [actionTypes.LOCATION_SETTINGS_FETCHED]: locationSettingsFetched,
    [actionTypes.CONVO_DETAILS_FETCHED]: convoDetailsFetched,
};

function locationSettingsFetched(
    state: TeamsState,
    action: LocationSettingsFetchedAction,
): TeamsState {
    return {
        ...state,
        ...buildTeams(action.payload.settings.teams),
    };
}

function buildTeams(teams: LocationSettingsTeam[]) {
    return teams.reduce((teams, team) => {
        teams[team.id] = {
            id: team.id,
            name: team.name,
            status: team.status.toLowerCase(),
            offlineMessage: team.offlineMessage,
            phone: team.phoneNumber,
            userIds: team.users.map(user => user.id),
        };
        return teams;
    }, {});
}

function convoDetailsFetched(state: TeamsState, action: ConvoDetailsFetchedAction): TeamsState {
    if (!action.payload.conversation.team) return state;

    return {
        ...state,
        [action.payload.conversation.team.id]: {
            id: action.payload.conversation.team.id,
            name: action.payload.conversation.team.name,
            status: Status.online,
            offlineMessage: action.payload.conversation.team.offlineMessage,
            phone: action.payload.conversation.team.phoneNumber,
            userIds: action.payload.conversation.team.userIds,
        },
    };
}

export default createReducer(initialState, handlers);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/teams.ts